var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1428_25283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9997 25.4166C19.5809 25.4166 24.9163 20.0812 24.9163 13.4999C24.9163 6.91867 19.5809 1.58325 12.9997 1.58325M12.9997 25.4166C6.41842 25.4166 1.08301 20.0812 1.08301 13.4999C1.08301 6.91867 6.41842 1.58325 12.9997 1.58325M12.9997 25.4166C16.2497 25.4166 17.333 19.9999 17.333 13.4999C17.333 6.99992 16.2497 1.58325 12.9997 1.58325M12.9997 25.4166C9.74967 25.4166 8.66634 19.9999 8.66634 13.4999C8.66634 6.99992 9.74967 1.58325 12.9997 1.58325M2.16634 17.8333H23.833M2.16634 9.16659H23.833",
    stroke: "#1E1C1C",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1428_25283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.8f4f8b0bbdf3f7332af9360c0e3c44ca.svg";
export { ForwardRef as ReactComponent };